<template lang="pug">
  .dropdown.dropdown-right.dropdown-top.options
    a.dropdown-toggle.btn.btn-lg.btn-primary.s-circle(tabindex="0")
      i.fas.fa-cog
    ul.menu
      li.menu-item.text-left(v-for="option in options" :key="option.key" :class="{ 'c-not-allowed': !option.enabledStatus.includes(balance.status) }")
        a.c-hand(:class="option.class" @click="$emit(option.event)" :disabled="!option.enabledStatus.includes(balance.status)")
          i(:class="option.icon")
          |  {{ option.label }}
        
</template>

<script>
export default {
  props: { balance: { type: Object, required: true } },
  computed: {
    options() {
      return [
        {
          key: 'closeBalance',
          label: 'Fechar balanço',
          icon: 'fas fa-fw fa-lock',
          class: 'text-error',
          enabledStatus: ['opened'],
          event: 'close-balance',
        },
        {
          key: 'payBalance',
          label: 'Pagar balanço',
          icon: 'fas fa-fw fa-money-bill-alt',
          enabledStatus: ['error', 'closed'],
          event: 'pay-balance',
        },
        {
          key: 'upgradeBalance',
          label: 'Atualiar balanço',
          icon: 'fas fa-fw fa-sync-alt',
          enabledStatus: ['opened'],
          event: 'upgrade-balance',
        },
      ]
    },
  },
}
</script>

<style lang="stylus" scoped>
a
  user-select none
  &[disabled="disabled"]
    pointer-events none
    opacity .5

.c-not-allowed
  cursor not-allowed


.options
  position fixed
  right 3rem
  bottom 3rem

  &.dropdown
    .menu
      min-width 200px
      top auto
      bottom 125%
      animation slide-up .15s ease 1

@keyframes slide-up
  0%
    opacity 0
    transform translateY(1.6rem)
</style>
